import { Pipe, PipeTransform } from '@angular/core';

/**
 * Joins an array into a string, optionally by a given property of each item.
 *
 * Example:
 *   [{ name: 'A' }, { name: 'B' }] | joinBy: 'name' -> "A, B"
 *   ['A', 'B'] | joinBy: null : ' / '              -> "A / B"
 *
 * Useful for displaying lists (e.g. regions, sites) without
 * manual looping or comma handling in templates.
 * Null and undefined values are filtered out, and the separator can be customized.
 */
@Pipe({
    name: 'joinBy',
    standalone: false,
})
export class JoinByPipe implements PipeTransform {
    transform<T>(items: T[] | null | undefined, key?: keyof T | null, separator = ', '): string {
        if (!items?.length) {
            return '';
        }

        return items
            .map(item => (key == null ? item : item[key]))
            .filter(value => value !== null && value !== undefined)
            .map(value => `${value}`)
            .join(separator);
    }
}
